import { useEffect, useState } from "react";
import axios from "axios";
import { Col, Row } from "antd";
import { Publication } from "interfaces/websiteContent";
import InfoBox from "components/InfoBox/InfoBox";
import Title from "antd/lib/typography/Title";
import eagleImage from "assets/images/publicationsImages/eagle.png";
import owlImage from "assets/images//publicationsImages/owl.png";
import EarlierSurveys from "./EarlierSurveys/EarlierSurveys";

const Publications = () => {
  const [surveyData, setSurveyData] = useState<Publication[]>([]);

  useEffect(() => {
    axios.get<Publication[]>("/website-contents/publications/").then(response => {
      setSurveyData(response.data);
    });
  }, []);

  const getFilteredAndSortedPublications = (arr: Publication[], type: number) => {
    return arr
      .filter(survey => {
        if (survey.publication_type === type) {
          return survey;
        }
        return false;
      })
      .sort((a, b) => new Date(b.publication_date).valueOf() - new Date(a.publication_date).valueOf());
  };

  const diplomundersøkelse = getFilteredAndSortedPublications(surveyData, 2);
  const alumniundersøkelsen = getFilteredAndSortedPublications(surveyData, 1);
  const koronaundersøkelsen = getFilteredAndSortedPublications(surveyData, 3);

  return (
    <>
      <Row justify="center" gutter={[0, 20]} style={{ margin: "4em 2em", marginTop: "2em" }}>
        <Row justify="center" style={{ width: "100%" }}>
          <Title level={1}>Publikasjoner</Title>
        </Row>
        <Row justify="center" gutter={[40, 40]}>
          <Col>
            <InfoBox
              imageLink={eagleImage}
              imageAlt=""
              title={diplomundersøkelse[0] ? diplomundersøkelse[0].title : "Diplomundersøkelsen"}
              text="Bindeleddet NTNU gjennomfører årlig en diplomundersøkelse blant uteksaminerte studenter ved 
                  institutt for Industriell økonomi og teknologiledelse. Undersøkelsen er web–basert, og utføres 
                  vanligvis i slutten av uteksamineringsåret. Den har som hensikt å belyse arbeids- og lønnssituasjonen 
                  til nyutdannede Indøkere, samt analysere trender og utviklinger fra forrige år. Diplomundersøkelsen 
                  lanseres vanligvis på nyåret."
              buttonText="Last ned"
              buttonUrlLink={
                diplomundersøkelse[0]?.publication_file.includes("http")
                  ? diplomundersøkelse[0]?.publication_file
                  : axios.defaults.baseURL + diplomundersøkelse[0]?.publication_file
              }
              downloadable
            />
          </Col>
          <Col>
            <InfoBox
              imageLink={owlImage}
              imageAlt=""
              title={alumniundersøkelsen[0] ? alumniundersøkelsen[0].title : "Alumniundersøkelsen"}
              text="Bindeleddet NTNU gjennomfører hvert tredje år en undersøkelse blant alle tidligere 
                  sivilingeniørstudenter ved institutt for Industriell økonomi og teknologiledelse med formål 
                  å kartlegge Indøkerens arbeidssituasjon samt se på utviklinger innen lønn, arbeidssted og 
                  arbeidsområde samt flere andre områder. Undersøkelsen strekker seg fra studenter uteksaminert 
                  i 1987 og fram til fjorårets kull."
              buttonText="Last ned"
              buttonUrlLink={
                alumniundersøkelsen[0]?.publication_file.includes("http")
                  ? alumniundersøkelsen[0]?.publication_file
                  : axios.defaults.baseURL + alumniundersøkelsen[0]?.publication_file
              }
              downloadable
            />
          </Col>
        </Row>
        <Row style={{ width: "100%", marginTop: "5em" }} justify="center">
          <Title level={2} style={{ textAlign: "center" }}>
            Se tidligere undersøkelser
          </Title>
        </Row>
        <Row justify="center">
          <EarlierSurveys
            surveyDiplom={diplomundersøkelse.slice(1)}
            surveyAlumini={alumniundersøkelsen.slice(1)}
            surveyCovid={koronaundersøkelsen}
          />
        </Row>
      </Row>
    </>
  );
};

export default Publications;
